<template>
  <div v-if="!onlyTable" class="grid md:grid-cols-4 sm:grid-cols-1 gap-1" >
    <div class="md:col-span-4 sm:col-span-1">
      <div class="mx-3 mb-4 lg:mb-5 row-auto">
        <slot name="header">
        </slot>
        <ButtonTeleporter>
          <slot name="header-buttons"></slot>
        </ButtonTeleporter>
      </div>
    </div>
    <div v-if="tablaDefault.reload && tablaDefault.filtros.length > 0" class="md:col-span-4 sm:col-span-1">
      <div class="my-2 mx-1 border border-gray-400 rounded-md p-4">
        <data-table-filters
          :on-buscar="tablaDefault.reload"
          :filtros="tablaDefault.filtros"
          :direction="'h'"
        />
      </div>
    </div>
    <div class="mx-1 md:col-span-4 sm:col-span-1 overflow-x-auto">
      <DataTable
        v-if="tablaDefault.style == 'table'"
        :options="tablaDefault"
        :update-table="updateTable"
      >
        <template #body="options">
          <slot name="table-body" v-bind="options"> </slot>
        </template>
        <template #details="{ row, isExpanded }">
          <slot name="details-tabla" v-bind="{ row, isExpanded }"> </slot>
        </template>
        <template v-for="(_, name) in $slots" :key="name" #[name]="slotData">
          <slot :name="name" v-bind="slotData"></slot>
        </template>
      </DataTable>
      <DataTableStyled
        v-else
        :options="tablaDefault"
      >
        <template #body="options">
          <slot name="table-body" v-bind="options"> </slot>
        </template>
        <template #details="{ row, isExpanded }">
          <slot name="details-tabla" v-bind="{ row, isExpanded }"> </slot>
        </template>
      </DataTableStyled>
    </div>
  </div>
  <div v-else class="mx-1 overflow-x-auto">
    <DataTable
      :options="tablaDefault"
      :update-table="updateTable"
    >
      <template #body="options">
        <slot name="table-body" v-bind="options"> </slot>
      </template>
      <template #details="{ row, isExpanded }">
        <slot name="details-tabla" v-bind="{ row, isExpanded }"> </slot>
      </template>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import { ref, type PropType, type Ref } from 'vue'
import type {
  IDataTable
} from '@/modules/Core/interfaces'
import { usePersistenciaFiltros } from '@/modules/Core/composables/usePersistenciaFiltros'
defineSlots<{
  header: () => unknown
  'header-buttons': () => unknown
  'table-body': () => unknown
  'details-tabla': () => unknown
  [key: string]: () => unknown
}>()

const props = defineProps({
  onlyTable: {
    type: Boolean,
    default: false
  },
  tabla: {
    type: Object as PropType<IDataTable<unknown>>,
    require: true,
    default: null
  }
})

const { tabla } = props
const tablaDefault: Ref<IDataTable<unknown>> = ref(tabla as IDataTable<unknown>)
tablaDefault.value.title = tablaDefault.value.title || ''
tablaDefault.value.identification = tablaDefault.value.title.replaceAll(
  ' ',
  '_'
)
usePersistenciaFiltros(tablaDefault)
const updateTable = (newValue: IDataTable<unknown>) => {
  tablaDefault.value = newValue
}
</script>
